import React from "react";
import Icon from "../Icon";

export default (props) => (
  <Icon viewBox="0 0 72 56" {...props}>
    <path
      d="M48 24c-15 0-18-12-30-12 0 0 0 0 0 0-6.627 0-12 5.373-12 12h0c0 6.627 5.373 12 12 12h3.5M32 18c3-4 12-10 20-10 0 0 0 0 0 0 7.732 0 14 6.268 14 14h0c0 7.732-6.268 14-14 14 0 0 0 0 0 0H40m-25 0c0 2.667-.333 6.667-1 12h39c-1.333-5.333-2-9.333-2-12"
      fill="none"
    />
  </Icon>
);
